export const NOTIFICATION_DELAY = 7000;

export const NOTIFICATION_TYPE_MAIN = 'withReduxForm/notification-type/main';
export const NOTIFICATION_TYPE_FOCUS_PANEL =
    'withReduxForm/notification-type/focus-panel';
export const NOTIFICATION_TYPE_PROPS = 'withReduxForm/notification-type/props';
